import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useLenis } from "./hooks/useLenis";
import LandingPage from "./pages/LandingPage";
import AdminPage from "./pages/AdminPage";
import PaymentReturn from "./pages/PaymentReturn";
import { MusicToggle } from "./components/MusicToggle";

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-void text-slate-100">
        <div className="noise-overlay" aria-hidden="true" />
        <MusicToggle />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/payment/success" element={<PaymentReturn type="success" />} />
          <Route path="/payment/cancel" element={<PaymentReturn type="cancel" />} />
        </Routes>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
